export default __webpack_public_path__ + "static/media/menu-open.bb98f30e.svg";